import { filter } from "lodash";

export default  {	
	data () {
		return { 
			filter: {
				name: null,
				id_list: null
			},
		}
	},
	async created () 
	{
		// frontend this.searchGetIdb({tabla:'servicios_nuevos',campo:'iniciolabores',value:'',principal:'info_afiliacion'})		
	},
	computed: 
	{
		entidades() 
		{
			if(this.filter.name!=null)
			{
				switch(this.filter.name.name)
				{
					case 'Eps':
						return this.lists.list_eps
					break; 
					case 'Riesgo':
						return this.lists.list_riesgo
					break; 
					case 'Ccf':
						return this.lists.list_ccf
					break; 
					case 'Afp':
						return this.lists.list_afp
					break; 
					case 'Traslado':
						return this.lists.list_eps
					break; 
				}
				
			}
			return []
		}
	},
	methods: {
	  change(action) {
		const { editor } = this.$refs;
  
		switch (action) {
		  case 'crop':
			editor.crop();
			break;
  
		  case 'clear':
			editor.clear();
			break;
  
		  case 'restore':
			editor.restore();
			break;
  
		  case 'remove':
			editor.reset();
			break;
  
		  default:
		}
	  },
	},
}
